//
// Popup
//

document.addEventListener('click', (event) => {
  const element = event.target
  if (element instanceof HTMLElement === false) return

  const anchorElement = element.closest('a.popup-link')
  if (anchorElement == null) return

  const href = anchorElement.getAttribute('href')
  if (href == null || href.startsWith('http') === false) return

  event.preventDefault()
  event.stopPropagation()

  let width = parseInt(anchorElement.getAttribute('data-popup-width') || '')
  if (isNaN(width) || width <= 0) width = 600

  let height = parseInt(anchorElement.getAttribute('data-popup-height') || '')
  if (isNaN(height) || height <= 0) height = 600

  const features = new Map<string, string>()
  features.set('width', width.toString())
  features.set('height', height.toString())
  features.set('left', (window.screenX + (window.outerWidth - width) / 2).toString())
  features.set('top', (window.screenY + (window.outerHeight - height) / 2).toString())
  features.set('toolbar', '0')
  features.set('location', '0')
  features.set('status', '1')
  features.set('menubar', '0')
  features.set('scrollbars', '1')
  features.set('resizable', '1')

  window.open(
    href,
    '_blank',
    Array.from(features.entries())
      .map(([key, value]) => `${key}=${value}`)
      .join(',')
  )
})
